<div class="flex flex-col gap-4">
    @if (isLoadingData) {
        <div class="flex justify-center">
            <p-progress-spinner ariaLabel="loading" />
        </div>
    } @else {
        <p-table
            [value]="ebayMarketplaceStockOffers.marketplaces"
            [paginator]="false"
            [showCurrentPageReport]="false"
            [size]="'small'"
            dataKey="marketplace_id"
        >
            <ng-template #header>
                <tr>
                    <th>Magasin</th>
                    <th>SKU</th>
                    <th>Prix</th>
                    <th>Qte</th>
                    <th>Titre</th>
                    <th>Description</th>
                    <th>Publié</th>
                    <th>URL</th>
                    <th></th>
                </tr>
            </ng-template>

            <ng-template #body let-marketplace>
                <tr>
                    <td>{{ marketplace.nom }}</td>
                    <td>{{ marketplace.sku }}</td>
                    <td>{{ marketplace.prix | currency: marketplace.devise }}</td>
                    <td>{{ ebayMarketplaceStockOffers.quantite || '-' }}</td>
                    <td><div [class]="marketplace.titre_manuel ? 'text-sky-500 dark:text-sky-400' : ''" [innerHTML]="(marketplace.titre || '-') | nl2br"></div></td>
                    <td><div [class]="marketplace.description_manuelle ? 'text-sky-500 dark:text-sky-400' : ''" [innerHTML]="(marketplace.description || '-') | nl2br"></div></td>
                    <td><p-tag [value]="marketplace.publie ? 'Oui' : 'Non'" [severity]="marketplace.publie ? 'success' : 'danger'" /></td>
                    <td>
                        @if(marketplace.url) {
                            <a [href]="marketplace.url" target="_blank" pButton icon="pi pi-shopping-bag" size="small" [outlined]="true" pTooltip="Lien Ebay" tooltipPosition="bottom"></a>
                        } @else {
                            <span pTooltip="Ebay" tooltipPosition="bottom" class="pi pi-shopping-bag p-1.5 w-8 text-center !text-sm text-surface-500 dark:text-surface-400"></span>
                        }
                    </td>
                    <td>
                        <div class="flex flex-row gap-2 flex-nowrap">
                            @if(marketplace.exclue){
                                <p-button icon="pi pi-pause-circle" text pTooltip="Annonce suspendu d'eBay" severity="warn" tooltipPosition="bottom" (click)="excludingMarketplace(marketplace, true)" [loading]="isExcludingMarketplace(marketplace)" [disabled]="isExcludingMarketplace(marketplace)" />
                            } @else {
                                <p-button icon="pi pi-play-circle" text pTooltip="Annonce active sur eBay" severity="success" tooltipPosition="bottom" (click)="excludingMarketplace(marketplace, false)" [loading]="isExcludingMarketplace(marketplace)" [disabled]="isExcludingMarketplace(marketplace)" />
                            }
                            <p-button icon="pi pi-sync" text pTooltip="Synchronisation" tooltipPosition="bottom" (click)="synchronizeMarketplace(marketplace)" [loading]="isSynchronizingMarketplace(marketplace)" [disabled]="isSynchronizingMarketplace(marketplace)" />
                            <p-button icon="pi pi-pencil" text severity="info" pTooltip="Éditer" tooltipPosition="bottom" (click)="onOpenEditModal(marketplace)" />
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template #emptymessage>
                <tr>
                    <td colspan="9">Aucune offre trouvée pour ce stock sur les boutiques eBay.</td>
                </tr>
            </ng-template>
        </p-table>
    }
    <div class="flex flex-row justify-between mt-4">
        <p-button label="Annuler" icon="pi pi-times" text severity="danger" (click)="hideDialog()" />
        <p-button label="Tous synchroniser" icon="pi pi-sync" iconPos="right" type="submit" (click)="synchronizeMarketplace(null)" [loading]="isSynchronizingMarketplace(null)" [disabled]="isSynchronizingMarketplace(null)" />
    </div>
</div>
